import { createContext, useContext, useState } from 'react';

import { useStableCallback } from 'core/hooks/useStableCallback';
import Dialog from 'core/ui/Dialog';

import Form from './Form';

const ctx = createContext<null | ((deck: TDeck) => Promise<TWord[] | null>)>(
  null
);

let promiseResolve: ((cards: TWord[] | null) => void) | null = null;

export const WithBatchCreator: TSimpleHoC = Comp =>
  function WithAddWordsDialog(props) {
    const [deck, setDeck] = useState<TDeck | null>(null);

    const open = useStableCallback((deck: TDeck) => {
      setDeck(deck);
      return new Promise<TWord[] | null>(resolve => (promiseResolve = resolve));
    });

    const close = useStableCallback((cards: TWord[] | null) => {
      setDeck(null);
      orDie(promiseResolve)(cards);
    });

    return (
      <ctx.Provider value={open}>
        <Dialog isOpen={!!deck}>
          {deck && <Form deck={deck} close={close} />}
        </Dialog>
        {/* @ts-ignore */}
        <Comp {...props} />
      </ctx.Provider>
    );
  };

export const useBatchCreator = () => orDie(useContext(ctx));
